import axios from 'axios';
import Swal from "sweetalert2";

export class BaseService {
    constructor() {
        this.token = '';
    }

    async fetch(method, path, body, contentType = 'application/json') {
        this.token = localStorage.getItem(ENVIRONMENT.AUTH_TOKEN);

        const addKpisOpsPrefix =
            !ENVIRONMENT.IS_OPERATIONS_KPIS ||
            ["organizations", "me"].filter((route) => path.includes(route))
                .length > 0;

        if (!addKpisOpsPrefix) path = '/ops' + path;

        let options = {
            url: ENVIRONMENT.API_HOST + path,
            method: method,
            headers: {
                'Accept': 'application/json',
                'Content-Type': contentType
            },
            withCredentials: true
        };

        if (this.token) options.headers['Authorization'] = 'Bearer ' + this.token;
        if (body) options.data = body;
        try {
            const response = await axios(options);
            this.verifyTimeOut(response);
            return response;
        } catch (error) {
            this.verifyTimeOut(null, error);
            return error;
        }
    }

    verifyTimeOut (response, error = null) {
        if (['logout', 'login', 'reset-password'].find(allowedRoute => window.location.href.includes(allowedRoute))) return;
        const hasResponse = response && response.data && response.data.data;

        if( (hasResponse && response.data.data.code === 401) || (error && error.toString().includes('code 401'))){
            Swal.fire({
                imageUrl: '/img/clock.svg',
                title: 'Session Expired',
                text: 'You will be redirected to the login page.',
                confirmButtonText: 'Login',
            }).then((result) => {
                location.href = "/logout";
            })
        }
    }
}
